// ======================================================================
// File: QAInspectionPage.jsx
// Module: PPE → Quality → Incoming QA
// Purpose: Route container for QA Inspection List
// ======================================================================

import React from "react";
import QAInspectionList from "../components/inspections/QAInspectionList";

export default function QAInspectionPage() {
  return <QAInspectionList />;
}